var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import mergeWith from "lodash.mergewith";
import { brand } from "./Brand";
import { global } from "./Global";
function isFunction(value) {
    return typeof value === "function";
}
export var pipe = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (v) {
        return fns.reduce(function (a, b) { return b(a); }, v);
    };
};
function mergeThemeOverride() {
    var overrides = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        overrides[_i] = arguments[_i];
    }
    return mergeWith.apply(void 0, __spreadArray(__spreadArray([{}], overrides, false), [mergeThemeCustomizer], false));
}
function mergeThemeCustomizer(source, override, key, object) {
    if ((isFunction(source) || isFunction(override)) &&
        Object.prototype.hasOwnProperty.call(object, key)) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // @ts-ignore
            var sourceValue = isFunction(source) ? source.apply(void 0, args) : source;
            // @ts-ignore
            var overrideValue = isFunction(override) ? override.apply(void 0, args) : override;
            return mergeWith({}, sourceValue, overrideValue, mergeThemeCustomizer);
        };
    }
    // fallback to default behaviour
    return undefined;
}
export function extendTheme() {
    var extensions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        extensions[_i] = arguments[_i];
    }
    var overrides = __spreadArray([], extensions, true);
    var baseTheme = extensions[extensions.length - 1];
    if (overrides.length > 1) {
        overrides = overrides.slice(0, overrides.length - 1);
    }
    else {
        baseTheme = brand;
    }
    var result = pipe.apply(void 0, overrides.map(function (extension) { return function (prevTheme) {
        return isFunction(extension)
            ? extension(prevTheme)
            : mergeThemeOverride(prevTheme, extension);
    }; }))(baseTheme);
    return __assign(__assign({}, global), { brand: result });
}
